import * as fromAppointments from '../actions/appointments.actions';
import { ClaimAppointmentInterface } from '@app/my-zone/pages/claims/store/entity/appointment.interface';
import * as fromClearActions from '../actions/clear.actions';

/**
 *  ids equals correspondentie_volgnummer
 */
export interface State {
    ids: string[];
    entities: { [id: string]: ClaimAppointmentInterface };
    loading: boolean;
    loaded: { [id: string]: boolean };
    errors: { [id: string]: any[] };
}

const initialState: State = {
    ids: [],
    entities: {},
    loading: false,
    loaded: {},
    errors: {},
};

/**
 *  Object.assign(target, ...sources);
 *
 *  Properties in the target object will be overwritten by properties in the sources if they have the same key.
 *  Later sources' properties will similarly overwrite earlier ones.
 *
 *  Object.assign({}, currentEntities, newEntities);
 */

export function reducer(state = initialState, action: fromAppointments.Actions): State {
    switch (action.type) {
        case fromAppointments.LOAD: {
            return {
                ...state,
                loading: true,
            };
        }

        // Als er geen afspraken kunnen zijn dan is afspraken is null
        // Als er afspraken kunnen zijn dan is afspraken een array
        // Als er afspraken zijn dan is er een array met objecten
        // Als er geen afspraken maar wel kunnen zijn is er een array met een lege array
        case fromAppointments.LOAD_SUCCESS: {
            const dossier_volgnummer = action.payload.dossier_volgnummer;
            const afspraken = action.payload.afspraken ? action.payload.afspraken : [[]];
            const afspraak = Array.isArray(afspraken[0]) ? { netwerk_id: 'NONE' } : afspraken[0];

            // Create new ids
            const ids = state.ids.filter((id) => id !== dossier_volgnummer);

            // Copy new entitie to old entities
            const entity = state.entities[dossier_volgnummer];
            const newEntity = Object.assign({}, entity, afspraak);

            // Loaded true
            const newLoadedState = { [action.payload.dossier_volgnummer]: true };

            // Return new state
            return {
                ...state,
                ids: [...ids, dossier_volgnummer],
                entities: Object.assign({}, state.entities, {
                    [dossier_volgnummer]: newEntity,
                }),
                loading: false,
                loaded: Object.assign({}, state.loaded, newLoadedState),
            };
        }

        case fromAppointments.SET: {
            return {
                ...state,
                loading: true,
            };
        }

        case fromAppointments.SET_SUCCESS: {
            const dossier_volgnummer = action.payload.dossier_volgnummer;
            let afspraak = { ...state.entities[dossier_volgnummer] };

            if (!afspraak) {
                return state;
            }

            // Change values
            afspraak.btn_afspraakmaken = false;
            afspraak.btn_eigenhersteller = false;
            afspraak.netwerk_id_omschrijving = 'Nieuwe Afspraak';
            afspraak = {
                ...afspraak,
                gebeurtenis: {
                    ...afspraak.gebeurtenis,
                    schadeherstel_gebeurtenis_datum: action.payload.gebeurtenis.schadeherstel_gebeurtenis_datum,
                    schadeherstel_gebeurtenis_tijdstip: action.payload.gebeurtenis.schadeherstel_gebeurtenis_tijdstip,
                    naam: action.payload.gebeurtenis.name,
                    straatnaam: action.payload.gebeurtenis.street_name,
                    huisnummer: action.payload.gebeurtenis.civic_number,
                    postcode: action.payload.gebeurtenis.postal_code,
                },
            };

            return {
                ...state,
                entities: Object.assign({}, state.entities, {
                    [dossier_volgnummer]: afspraak,
                }),
                loading: false,
            };
        }

        case fromAppointments.SET_ERRORS: {
            const dossier_volgnummer = action.payload.dossier_volgnummer;
            const errors = action.payload.errors;

            if (!errors) {
                return state;
            }

            return {
                ...state,
                errors: Object.assign({}, state.errors, {
                    [dossier_volgnummer]: errors,
                }),
                loading: false,
            };
        }

        case fromAppointments.CLEAR_ERRORS: {
            const dossier_volgnummer = action.payload.dossier_volgnummer;

            if (!dossier_volgnummer) {
                return state;
            }

            return {
                ...state,
                errors: Object.assign({}, state.errors, {
                    [dossier_volgnummer]: [],
                }),
                loading: false,
            };
        }

        case fromClearActions.CLEAR_CLAIMS_STORE: {
            return initialState;
        }

        default: {
            return state;
        }
    }
}

export const getEntities = (state: State) => state.entities;
export const getIds = (state: State) => state.ids;
export const getErrors = (state: State) => state.errors;
export const getLoaded = (state: State) => state.loaded;
export const isLoading = (state: State) => state.loading;
